export default function () {
  const moduleName = 'form'
  Array.from(document.querySelectorAll('form')).forEach((wrapper) => {
    if (wrapper.dataset[moduleName + 'Init'] === 'true') return
    wrapper.dataset[moduleName + 'Init'] = 'true'

    const requiredFields = wrapper.querySelectorAll('input[required], textarea[required]')

    wrapper.addEventListener('submit', (event) => {
      event.preventDefault()

      // Нет капчи
      if (!window?.smartCaptcha?.getResponse()) {
        alert('Вы не прошли капчу, чтобы подтвердить, что вы не робот.')
        return false
      }

      let cancelSending = false

      Array.from(requiredFields).every((requiredField) => {
        if (requiredField.type === 'checkbox') {
          if (requiredField.checked) {
            return true
          } else {
            cancelSending = true
            return false
          }
        }

        if (requiredField.value !== '') {
          return true
        } else {
          cancelSending = true
          return false
        }
      })

      if (cancelSending) {
        alert('Пожалуйста, заполните обязательные поля формы!')
        return false
      }

      const xhr = new XMLHttpRequest()

      xhr.open('POST', 'php/mail.php')
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
      xhr.onreadystatechange = () => {
        if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
          const data = JSON.parse(xhr.responseText)
          const captchaStatus = data.captchaStatus
          const captchaMessage = data.captchaMessage

          if (captchaStatus) {
            const messageOnSuccess = wrapper.querySelector('.js-message-on-success')
            wrapper.innerHTML = ''
            wrapper.appendChild(messageOnSuccess)
            messageOnSuccess.classList.add('visible')
          } else {
            alert(captchaMessage)
          }
        }
      }
      xhr.send(new FormData(wrapper))
    })
  })
};
